// extracted by mini-css-extract-plugin
export default {"container":"CookieBanner_container__9t00L","buttons":"CookieBanner_buttons__bLx2x","forceSingleLine":"CookieBanner_forceSingleLine__OLk11"};